var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.375V15.5H3.625L12.8417 6.28333L9.71667 3.15833L0.5 12.375ZM15.2583 3.86666C15.3356 3.78956 15.3969 3.69799 15.4387 3.59718C15.4805 3.49637 15.502 3.3883 15.502 3.27916C15.502 3.17002 15.4805 3.06195 15.4387 2.96114C15.3969 2.86033 15.3356 2.76875 15.2583 2.69166L13.3083 0.741659C13.2312 0.664406 13.1397 0.603116 13.0389 0.561298C12.938 0.51948 12.83 0.497955 12.7208 0.497955C12.6117 0.497955 12.5036 0.51948 12.4028 0.561298C12.302 0.603116 12.2104 0.664406 12.1333 0.741659L10.6083 2.26666L13.7333 5.39166L15.2583 3.86666Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil_icon.f3ef1cd8733573fe59a379ed6846a2d8.svg";
export { ForwardRef as ReactComponent };